import {useEffect, useState} from "react";
import {HideMainLoading} from "../../components/template/architecture";
import {Link} from "react-router-dom";
import '../../static/css/home/signup.css';
import {ThinArrowLeft, ThinLeavesIcon, ThinWiFiIcon} from "../../components/icons/material-icons";
import {ServerImage} from "../../components/api/webservice";
import {HomeInstagramComponent} from "../home/ig";

export const HomeAboutSignupScreen = () => {
    useEffect(() => {
        document.title = "پیش ثبت‌نام | دبستان هوشمند نهال";
        HideMainLoading();
    }, []);
    return (
        <>
            <div className="home-signup-hero">
                <div className="container">
                    <i>
                        <em style={{backgroundImage:'url(/logo.png)'}}/>
                    </i>
                    <h1>ثبت‌نام در نهال</h1>
                    <b>دبستان هوشمند و مهارتی</b>
                    <Link to={"/signup/login"}>
                        <span>ثبت نام در نهال</span>
                        <ThinArrowLeft/>
                    </Link>
                </div>
            </div>
            <div className="welcome-levels">
                <div className="container" data-aos="fade-up" data-aos-duration={1000} data-aos-delay={100}>
                    <h2>ثبت نام بصورت کاملا آنلاین</h2>
                    <p>برای ثبت‌نام اولیه در نهال نیاز به مراجعه حضوری به مدرسه نیست و به راحتی می‌توانید طبق مراحل زیر در مدرسه ثبت نام نمایید.</p>
                    <div className="row justify-content-center">
                        <div className="col-md-6">
                            <div className="welcome-levels-item">
                                <i>۱</i>
                                <div>
                                    <b>ثبت‌نام اولیه</b>
                                    <span>در این مرحله شما باید مشخصات درخواست شده را در صفحه ثبت‌نام تکمیل نمایید.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-md-6">
                            <div className="welcome-levels-item">
                                <i>۲</i>
                                <div>
                                    <b>تایید ثبت‌نام توسط آموزشگاه</b>
                                    <span>در این مرحله کادر اداری نهال، در اولین فرصت اقدام به بررسی اطلاعات شما و تایید حساب شما براساس ظرفیت می‌نمایند.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-md-6">
                            <div className="welcome-levels-item">
                                <i>۳</i>
                                <div>
                                    <b>دریافت پیامک تاییدیه</b>
                                    <span>پس از تایید توسط آموزشگاه، یک پیامک تاییدیه و اطلاع رسانی برای انجام ادامه ثبت نام برای شما ارسال می‌گردد.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-md-6">
                            <div className="welcome-levels-item">
                                <i>۴</i>
                                <div>
                                    <b>پرداخت هزینه</b>
                                    <span>در این قسمت می‌توانید مجددا به بخش ثبت‌نام وارد شده و سپس پیش‌پرداخت شهریه دانش‌آموز را پرداخت کرده و ثبت نام دانش آموز را قطعی نمایید.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{background:'#fff',padding:'50px 0'}}>
                <div className="container">
                    <HomeInstagramComponent/>
                </div>
            </div>
        </>
    );
};